// extracted by mini-css-extract-plugin
export default {"ImageSlider":"ImageSlider2_ImageSlider__9owsn","ImageSlider__DotsContainer":"ImageSlider2_ImageSlider__DotsContainer__2hp4R"};